import React from 'react'

const Instruction = ({ content }) => (
  <div className="is-full py-0">
    <div className="notification is-danger is-light">
      {content}
    </div>
  </div>
);

export default Instruction;
